import {writable} from 'svelte/store';
export const storeAnnio = writable([]);
export const timeout = writable(false);